<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />

    <QuillInputS
      name="body"
      display-name=""
      placeholder="Body here"
      :value="block.quill"
      :editor-overlay="block.overlay"
      @quillChanged="quillChanged"
    ></QuillInputS>

    <div class="row my-3">
      <div class="col">
        <ImageUpload
          :file-path="block.file"
          @uploadCompleted="storeFile"
          @fileDeleted="deleteFile"
          context="block.image"
        ></ImageUpload>
      </div>

      <div class="col">
        <div class="mb-3">
          <label for="" class="text-muted">
            {{ 'Text position' | translate }}:
          </label>
          <select
            v-model="side_image_text_position"
            class="form-control"
            @change="change"
          >
            <option value="left">{{ 'left' | translate }}</option>
            <option value="">{{ 'right' | translate }}</option>
            <option value="top">{{ 'top' | translate }}</option>
            <option value="bottom">{{ 'bottom' | translate }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import route from './../../routes.js'
import ImageUpload from './../ImageUpload'
import QuillInputS from './../QuillInputS'
import _ from 'lodash'

export default {
  components: {
    ImageUpload,
    QuillInputS,
  },
  props: ['block', 'editing'],
  data() {
    return {
      side_image_text_position:
        _.get(this.block, 'settings.side_image_text_position') || '',
    }
  },
  methods: {
    change() {
      let previousSettings = _.get(this.block, 'settings')
      let newSettings = { ...this._data }
      if (previousSettings) {
        newSettings = {
          ...previousSettings,
          ...newSettings,
        }
      }
      newSettings = _(newSettings)
        .omitBy(_.isNil)
        .omitBy((value) => {
          return _.isEmpty(value) && !_.isInteger(value) && !_.isBoolean(value)
        })
        .value()
      if (_.isEmpty(newSettings)) {
        newSettings = null
      }

      this.block.settings = newSettings
    },
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },
    deleteFile() {
      this.block.file = null
      this.$emit('fileDeleted')
    },
    storeFile(filePath) {
      this.block.file = filePath
      this.$emit('saveAndContinue')
    },
    quillChanged(html, quill) {
      this.block.quill = quill
      this.block.html = html
    },
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },
  },
}
</script>

<style></style>
